import HARDCODE from '../../business-const/HardCode/HardCode'

import LABEL from '../../business-const/Label/Label'

import {
    GridItem3xs6,
    GridItem5xs6,
    GridItem6xs8,
    GridItem8xs12,
} from '../../business-components/Grid/Grid'

import pessoaFisicaJuridicaList from './Consorcio/pessoaFisicaJuridicaList'

import simNaoList from "./simNaoList"



const formPrimeiraReuniaoPadraoList = [
    {
        id: 5,
        descricao: 'Vai trabalhar até / Expectativa de Vida',
        default: false,
        grupoPergunta: '',
        type: HARDCODE.formTypeAposentadoriaExpectativaVidaClienteConjuge,
        compoeCompleto: true,
        tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsDiagnosticoAposentadoria,
        ordem: 1,
    },
    //Foi tratado em inicializaAjustaInclusoesAlteracoesExclusoesJsonInfoclient para zerar a ligação
    //das perguntas com o patrimônio quando idFormList = HARDCODE.idFormListDefault, que era até
    //então o único idFormList ligado a formPrimeiraReuniaoPadraoList
    //{
    //    id: 10,
    //    descricao: 'Qual é o valor do seu patrimônio imobilizado?',
    //    descricaoResumida: 'Patrimônio (Imobilizado)',
    //    default: true,
    //    grupoPergunta: '',
    //    type: 'ValorPerc',
    //    atualiza: HARDCODE.formListAtualizaPatrimonioImobilizado,
    //    ordem: 10,
    //},
    {
        id: 15,
        descricao: 'Possui patrimônio imobilizado?',
        default: true,
        grupoPergunta: '',
        type: HARDCODE.formTypePatrimonioImobilizado,
        compoeCompleto: true,
        tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsDiagnosticoAposentadoria,
        ordem: 50,
    },
    //Foi tratado em inicializaAjustaInclusoesAlteracoesExclusoesJsonInfoclient para zerar a ligação
    //das perguntas com os recursos financeiros quando idFormList = HARDCODE.idFormListDefault, que era até
    //então o único idFormList ligado a formPrimeiraReuniaoPadraoList
    //{
    //    id: 20,
    //    descricao: 'Qual o valor total dos seus investimentos?',
    //    descricaoResumida: 'Recursos Financeiros',
    //    default: true,
    //    grupoPergunta: '',
    //    type: 'ValorPerc',
    //    atualiza: HARDCODE.formListAtualizaRecursosFinanceiros,
    //    atualizaIdRecursosFinanceiros: HARDCODE.idTipoRecursoFinanceiroOutros,
    //    ordem: 20,
    //},
    {
        id: 30,
        descricao: 'Possui recursos financeiros?',
        default: true,
        grupoPergunta: '',
        type: HARDCODE.formTypeRecursosFinanceiros,
        compoeCompleto: true,
        tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsDiagnosticoAposentadoria,
        ordem: 70,
    },
    //Foi tratado em inicializaAjustaInclusoesAlteracoesExclusoesJsonInfoclient para zerar a ligação
    //das perguntas com a receita mensal quando idFormList = HARDCODE.idFormListDefault, que era até
    //então o único idFormList ligado a formPrimeiraReuniaoPadraoList
    //{
    //    id: 40,
    //    descricao: 'Qual é a sua receita mensal?',
    //    descricaoResumida: 'Receita Anual',
    //    default: true,
    //    grupoPergunta: '',
    //    type: 'ValorValor',
    //    atualiza: HARDCODE.formListAtualizaReceitaMensal,
    //    ordem: 50,
    //},
    {
        id: 45,
        descricao: 'Possui receita mensal?',
        default: true,
        grupoPergunta: '',
        type: HARDCODE.formTypeReceitaMensal,
        compoeCompleto: true,
        tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsDiagnosticoAposentadoria,
        ordem: 5,
    },
    //Foi tratado em inicializaAjustaInclusoesAlteracoesExclusoesJsonInfoclient para zerar a ligação
    //das perguntas com o dia a dia quando idFormList = HARDCODE.idFormListDefault, que era até
    //então o único idFormList ligado a formPrimeiraReuniaoPadraoList
    //{
    //    id: 50,
    //    descricao: 'Qual é a sua despesa mensal?',
    //    descricaoResumida: 'Despesa Anual',
    //    default: true,
    //    grupoPergunta: '',
    //    type: 'ValorValor',
    //    atualiza: HARDCODE.formListAtualizaDiaDia,
    //    ordem: 40,
    //},
    {
        id: 55,
        descricao: 'Possui despesas do dia a dia?',
        default: true,
        grupoPergunta: '',
        type: HARDCODE.formTypeDiaDia,
        compoeCompleto: true,
        tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsDiagnosticoAposentadoria,
        ordem: 10,
    },
    {
        id: 60,
        descricao: 'Possui financiamentos?',
        default: true,
        grupoPergunta: '',
        type: HARDCODE.formTypeFinanciamento,
        compoeCompleto: true,
        tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsDiagnosticoAposentadoria,
        ordem: 30,
    },
    {
        id: 70,
        descricao: 'Possui projetos de vida/sonho?',
        default: true,
        grupoPergunta: '',
        type: HARDCODE.formTypeProjetoVidaSonho,
        compoeCompleto: true,
        tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsDiagnosticoAposentadoria,
        ordem: 40,
    },
    {
        id: 80,
        descricao: 'Possui despesas com educação?',
        default: true,
        grupoPergunta: '',
        type: HARDCODE.formTypeEducacao,
        compoeCompleto: true,
        tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsDiagnosticoAposentadoria,
        ordem: 20,
    },
    {
        id: 85,
        descricao: 'Solicitação de Arquivos',
        default: true,
        grupoPergunta: '',
        type: HARDCODE.formTypeSolicitacaoArquivo,
        compoeCompleto: true,
        tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsQuestionario,
        ordem: 85,
    },
    {
        id: 90,
        descricao: 'Qual é a sua renda mensal?',
        descricaoResumida: 'Receita Anual',
        default: false,
        grupoPergunta: '',
        type: 'Valor',
        atualiza: HARDCODE.formListAtualizaReceitaMensal,
        identificaId: HARDCODE.identificaIdPerguntaRendaMensal,
        GridItemDescricao: GridItem5xs6,
        tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsDiagnosticoAposentadoria,
        ordem: 90,
    },
    {
        id: 100,
        descricao: 'Qual é o seu gasto mensal?',
        descricaoResumida: 'Gasto Anual',
        default: false,
        grupoPergunta: '',
        type: 'Valor',
        atualiza: HARDCODE.formListAtualizaDiaDia,
        identificaId: HARDCODE.identificaIdPerguntaGastoMensal,
        GridItemDescricao: GridItem5xs6,
        tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsDiagnosticoAposentadoria,
        ordem: 100,
    },
    {
        id: 110,
        descricao: 'Qual o valor total dos seus investimentos hoje?',
        descricaoResumida: 'Recursos Financeiros',
        default: false,
        grupoPergunta: '',
        type: 'Valor',
        atualiza: HARDCODE.formListAtualizaRecursosFinanceiros,
        atualizaIdRecursosFinanceiros: HARDCODE.idTipoRecursoFinanceiroOutros,
        identificaId: HARDCODE.identificaIdPerguntaRecursosFinanceiros,
        GridItemDescricao: GridItem5xs6,
        tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsDiagnosticoAposentadoria,
        ordem: 110,
    },
    {
        id: 120,
        descricao: 'Qual o valor de todo o seu patrimônio imobilizado (casa, carro, negócio, etc)?',
        descricaoResumida: 'Patrimônio (Imobilizado)',
        default: false,
        grupoPergunta: '',
        type: 'Valor',
        atualiza: HARDCODE.formListAtualizaPatrimonioImobilizado,
        identificaId: HARDCODE.identificaIdPerguntaPatrimonioImobilizado,
        GridItemDescricao: GridItem5xs6,
        tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsDiagnosticoAposentadoria,
        ordem: 120,
    },
    {
        id: 130,
        descricao: 'Qual a renda que você gostaria de ter na ' + LABEL.aposentadoria.toLowerCase() + '?',
        default: false,
        grupoPergunta: '',
        type: 'Valor',
        identificaId: HARDCODE.identificaIdPerguntaRendaAposentadoria,
        GridItemDescricao: GridItem5xs6,
        tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsDiagnosticoAposentadoria,
        ordem: 130,
    },
    {
        id: 400,
        descricao: 'Autoriza o envio do seu diagnóstico de aposentadoria por WhatsApp ou e-mail?',
        default: false,
        grupoPergunta: '',
        type: 'SimNaoCelular',
        list: simNaoList,
        identificaId: HARDCODE.identificaIdPerguntaLGPDCelular,
        GridItemDescricao: GridItem5xs6,
        tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsDiagnosticoAposentadoria,
        ordem: 400,
    },
    {
        id: 500,
        descricao: 'Valor do Crédito?',
        default: false,
        grupoPergunta: '',
        type: 'Valor',
        identificaId: HARDCODE.identificaIdPerguntaValorCredito,
        GridItemDescricao: GridItem3xs6,
        tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsConsorcio,
        ordem: 500,
    },
    {
        id: 510,
        descricao: 'Pessoa Física ou Jurídica?',
        default: false,
        grupoPergunta: '',
        type: 'List',
        list: pessoaFisicaJuridicaList,
        identificaId: HARDCODE.identificaIdPerguntaPessoaFisicaJuridica,
        GridItemDescricao: GridItem3xs6,
        GridItemRadioList: GridItem8xs12,
        tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsConsorcio,
        ordem: 510,
    },
    {
        id: 520,
        descricao: 'Prazo (meses)?',
        default: false,
        grupoPergunta: '',
        type: 'List',
        list: [
            {
                id: 100,
                descricao: '100',
                ordem: 100,
            },
            {
                id: 140,
                descricao: '140',
                ordem: 140,
            },
            {
                id: 180,
                descricao: '180',
                ordem: 180,
            },
            {
                id: 200,
                descricao: '200',
                ordem: 200,
            },
            {
                id: 220,
                descricao: '220',
                ordem: 220,
            },
            {
                id: 240,
                descricao: '240',
                ordem: 240,
            },
        ],
        identificaId: HARDCODE.identificaIdPerguntaPrazoMeses,
        GridItemDescricao: GridItem3xs6,
        GridItemRadioList: GridItem6xs8,
        tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsConsorcio,
        ordem: 520,
    },
    {
        id: 530,
        descricao: 'Lance Recurso Próprio?',
        default: false,
        grupoPergunta: '',
        type: 'List',
        list: [
            {
                id: 0,
                descricao: '0%',
                ordem: 0,
            },
            {
                id: 25,
                descricao: '25%',
                ordem: 25,
            },
            {
                id: 40,
                descricao: '40%',
                ordem: 40,
            },
            {
                id: 50,
                descricao: '50%',
                ordem: 50,
            },
            {
                id: 60,
                descricao: '60%',
                ordem: 60,
            },
        ],
        identificaId: HARDCODE.identificaIdPerguntaLanceRecursoProprio,
        GridItemDescricao: GridItem3xs6,
        GridItemRadioList: GridItem6xs8,
        tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsConsorcio,
        ordem: 530,
    },
    {
        id: 540,
        descricao: 'Lance Embutido?',
        default: false,
        grupoPergunta: '',
        type: 'List',
        list: [
            {
                id: 0,
                descricao: '0%',
                ordem: 0,
            },
            {
                id: 25,
                descricao: '25%',
                ordem: 25,
            },
            {
                id: 30,
                descricao: '30%',
                ordem: 30,
            },
        ],
        identificaId: HARDCODE.identificaIdPerguntaLanceEmbutido,
        GridItemDescricao: GridItem3xs6,
        GridItemRadioList: GridItem6xs8,
        tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsConsorcio,
        ordem: 540,
    },
    {
        id: 550,
        descricao: 'Em quanto meses você gostaria de comprar o imóvel?',
        default: false,
        grupoPergunta: '',
        type: 'List',
        list: [
            {
                id: 6,
                descricao: '6',
                ordem: 6,
            },
            {
                id: 12,
                descricao: '12',
                ordem: 12,
            },
            {
                id: 18,
                descricao: '18',
                ordem: 18,
            },
            {
                id: 24,
                descricao: '24',
                ordem: 24,
            },
            {
                id: 36,
                descricao: '36',
                ordem: 36,
            },
        ],
        identificaId: HARDCODE.identificaIdPerguntaMesesComprarImovel,
        GridItemDescricao: GridItem3xs6,
        GridItemRadioList: GridItem6xs8,
        tipoLinkCaptacaoLeads: HARDCODE.tipoLinkCaptacaoLeadsConsorcio,
        ordem: 550,
    },
]
 
export default formPrimeiraReuniaoPadraoList